export enum GameStatus {
  INITIALIZING = 'initializing',
  LOADING = 'loading',
  LOADED = 'loaded',
  PLAYING = 'playing',
  INITIALIZED = 'initialized',
  VALIDATED = 'validated',
  CORRECTION = 'correction',
  FINISHED = 'finished',
  RESTARTED = 'restarted',
}
